module.exports = __webpack_public_path__ + "img/20_109.22605a11.png";